import { useFormContext } from 'react-hook-form';
import { FormFieldFiguresAndTables } from '@publishing-engine/domain/types/article';
import FiguresAndTablesForm from 'src/components/Submission/GenericFieldComponents/FiguresAndTables/FigureForm';
import { IFigureValue } from 'src/components/Submission/GenericFieldComponents/FiguresAndTables/FiguresAndTablesUpdateModal';

const FiguresAndTables = ({
  fieldConfig,
  submissionContextId
}: {
  fieldConfig: FormFieldFiguresAndTables;
  submissionContextId: string;
}) => {
  const methods = useFormContext<IFigureValue>();

  return (
    <FiguresAndTablesForm
      config={fieldConfig}
      methods={methods}
      submissionContextId={submissionContextId}
      formContext="create"
    />
  );
};

export default FiguresAndTables;
